import { render, staticRenderFns } from "./DepositPool.vue?vue&type=template&id=716ee750&scoped=true&"
import script from "./DepositPool.vue?vue&type=script&lang=js&"
export * from "./DepositPool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716ee750",
  null
  
)

export default component.exports